import { AppStorage } from './app-storage';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { b64ToUtf8, utf8ToB64 } from '../../../utils/utils';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export class StorageImpl implements AppStorage {

  private _ls: Storage;
  private _baseHref: string;

  constructor(ls: Storage, router: Router, @Inject(PLATFORM_ID) private platform: Object) {
    this._baseHref = (router as any).location._baseHref;
    this._ls = ls;
  }

  public remove(key: string): any {
    if (isPlatformBrowser(this.platform)) {
      let value = this.get(key + this._baseHref);
      this._ls.removeItem(utf8ToB64(key + this._baseHref));
      //noinspection TypeScriptUnresolvedFunction
      let removed = _.isNil(this.get(key));
      return removed ? value : null;
    }
    return null;
  }

  public put(key: string, value: any): any {
    if (isPlatformBrowser(this.platform)) {
      let prev = this.get(key + this._baseHref);
      let next = utf8ToB64(JSON.stringify(value));
      this._ls.setItem(utf8ToB64(key + this._baseHref), next);
      return prev;
    }
    return null;
  }

  public get(key: string) {
    if (isPlatformBrowser(this.platform)) {
      let value = this._ls.getItem(utf8ToB64(key + this._baseHref));
      if (value) {
        try {
          value = b64ToUtf8(value);
        } catch (e) {
          console.log(`${key} was not encrypted. Returning bare state`);
        }
        return JSON.parse(value);
      }
      return null;
    }
    return null;
  }

  public keys(): string[] {
    return Object.keys(this._ls).filter(k => _.isString(this._ls[k]));
  }

  public values(): any[] {
    return this.keys().map(k => this.get(k));
  }

  public entries(): { key: string; value: any }[] {
    let keys = this.keys();
    let values = this.values();
    let entries = [];
    for (let idx in keys) {
      if (keys.hasOwnProperty(idx)) {
        entries.push({
          key: keys[idx],
          value: values[idx]
        });
      }
    }
    return entries;
  }

  public clear(): void {
    if (isPlatformBrowser(this.platform)) {
      this._ls.clear();
    }
  }
}
